import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Divider, Form, Input } from 'antd';
import { NameRuler, PasswordRuler } from '@dofleini/validator';
import PageLayout from '../../components/PageLayout';
import { useSignUp } from '../../hooks/useAuthentication';
import Password from '../../components/Password';
import CaptchaCanvas from '../../components/CaptchaCanvas';

function SignUpForm ({ onSent, onLogin, useCaptcha, ...rest }) {
  const { t } = useTranslation('authentication');
  const { onSignUp, isLoading, error } = useSignUp(onSent);
  const [matching, setMatching] = useState(!useCaptcha);

  return (
    <PageLayout error={error} title={'signup.title'} onBack={onLogin}>
      <Form
        scrollToFirstError
        name="normal_login"
        layout={'vertical'}
        className="login-form"
        onFinish={onSignUp}
      >
        <Form.Item
          name="firstName"
          rules={[
            { required: true },
            NameRuler
          ]}
        >
          <Input
            disabled={isLoading}
            size={'large'}
            placeholder={t('name')}
          />
        </Form.Item>

        <Form.Item
          name="email"
          rules={[
            { required: true },
            { type: 'email' }
          ]}
        >
          <Input
            disabled={isLoading}
            size={'large'}
            placeholder={t('email')}
          />
        </Form.Item>

        <Form.Item
          name="password"
          help={'  '}
          rules={[{ required: true }, PasswordRuler]}
        >
          <Password
            lateral={false}
            disabled={isLoading}
            size={'large'}
            placeholder={t('password')}
          />
        </Form.Item>

        {useCaptcha && <Form.Item name="captcha" required>
          <CaptchaCanvas t={t} handleMatching={setMatching} {...rest}/>
        </Form.Item>}

        <Button
          size={'large'}
          disabled={isLoading || !matching}
          loading={isLoading}
          type="primary" htmlType="submit"
          className="login-form-button  w-full">
          {t('signup.action')}
        </Button>
        <Divider className={'my-3'}/>
        <div className={'text-center'}>
          {t('signup.accept')}<Link to={'/terminos-condiciones'}>{t('termAndConditions')}</Link>
        </div>
      </Form>
    </PageLayout>
  );
}

export default SignUpForm;

SignUpForm.propTypes = {
  onLogin: PropTypes.func,
  onSent: PropTypes.func,
  useCaptcha: PropTypes.bool
};
